const routes = {
  index: "/",
  login: "/login",
  "forget-password": "/forget-password",
  register: "/register",
  dashboard: {
    index: "dashboard",
  },
  profile: {
    index: "dashboard/profile",
  },
  authentication: {
    index: "dashboard/authentication",
  },
  notifications: {
    index: "dashboard/notifications",
  },
  properties: {
    index: "dashboard/properties",
    "my-properties": {
      index: "my-properties",
      show: "show/:id",
      calender: "calender/:id",
    },
    add: "add-property",
    show: "show/:id",
  },
  tickets: {
    index: "dashboard/tickets",
    add: "create-ticket",
    show: "show/:id",
  },
  messages: {
    index: "dashboard/messages",
  },
  financial: {
    index: "dashboard/financial",
  },
  transaction: {
    index: "/transaction",
  },
  ...(process.env.REACT_APP_CUSTOMER_CLUB === "true" && {
    customerClub: {
      index: 'dashboard/customer-club',
      scorestable:"customer-club/score-table",
      myscore:"customer-club/my-scores",
      scoremarket:"customer-club/score-market",
      myproduct:"customer-club/my-product",
      "score-table": {
        index: 'customer-club/score-table'
      },
      "my-scores": {
        index: 'customer-club/my-scores'
      },
      "score-market": {
        index: 'customer-club/score-market'
      }
    },
  }),
};

//publish/show/3

export default routes;
